const themeOptionsReceived = 'THEME_OPTIONS_RECEIVED';
const requestingThemeOptions = 'REQUESTING_THEME_OPTIONS';
const initialState = { themeOptions: [] };

export const actionCreators = {

	init: () => async (dispatch) => {

		const url = 'api/Theme/GetThemes/';
		const response = await fetch(url);
		if (response.ok) {
			dispatch({ type: requestingThemeOptions });

			const themeOptions = await response.json();

			dispatch({ type: themeOptionsReceived, themeOptions: themeOptions });
		}
	}
};

export const reducer = (state, action) => {
	state = state || initialState;

	if (action.type === themeOptionsReceived) {
		return {
			...state,
			themeOptions: action.themeOptions,
		};
	}
	return state;
};


// WEBPACK FOOTER //
// ./src/store/Theme.js